
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hedersutmarkelser",
      function () {
        return require("private-next-pages/hedersutmarkelser.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hedersutmarkelser"])
      });
    }
  